import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./pages/Navbar";

// Pages
import Home from "./pages/Home";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import AboutUs from "./pages/AboutUs";
import Career from "./pages/Career";
import CareerDetail from "./pages/CareerDetail";
import AdminCareer from "./pages/AdminCareer";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      {/* Global Navbar */}
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/career/:jobId" element={<CareerDetail />} />
        <Route path="/admin/career" element={<AdminCareer />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
